const STORAGE_KEY = "last_activity";
export const INACTIVITY_LIMIT = 1_800_000; // 30 minutes

export const useInactivityLogout = () => {
    const updateLastActivity = () => {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
    };

    const sessionHasExpired = () => {
        const lastActivity = localStorage.getItem(STORAGE_KEY);
        if (!lastActivity) return false;

        const elapsed = Date.now() - Number(lastActivity);
        return elapsed > INACTIVITY_LIMIT;
    };

    const clearLastActivity = () => {
        localStorage.removeItem(STORAGE_KEY);
    };

    return {
        updateLastActivity,
        sessionHasExpired,
        clearLastActivity,
    };
};
